import type { PlanTier } from './protocol';

export function isPaidTier(tier: PlanTier | null | undefined): boolean {
  return tier === 'paid';
}

export const PAID_FEATURE_HINT =
  'This feature needs a paid host plan (trial or subscription). Connect to a host that is on a paid tier.';
